<template>
    <div class="page white_bg">

        <header class="pageHeader paddingH16 white_bg bottomBorderBBB" style="line-height: 46px; ">
            <div class="borderLayout">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 11px;"
                              @click="back();"></span>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold hiddenOverflow"
                         style="height: 46px; ">
                        {{ title }}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px">
                    </div>
                </div>
            </div>
        </header>

        <div class="body">
            <div class="padding8">
                <div class="borderBBB">
                    <div class="color101010" style="padding: 16px 14px 12px;">
                        <div class="flexLayout font14r">
                            <div class="flexItem">
                                <div class="color777">
                                    历史累计收入
                                    <i class="icon eyeOpenedIcon size24 alignM" style="margin-top: -2px;"
                                       v-if="showTotalIncome" @click.prevent="showTotalIncome=!showTotalIncome"></i>
                                    <i class="icon eyeClosedIcon size24 alignM" style="margin-top: -2px;"
                                       v-else @click.prevent="showTotalIncome=!showTotalIncome"></i>
                                </div>
                                <div class="color101010" style="margin-top: 18px; min-height: 20px;">
                                    <template v-if="showTotalIncome">￥{{
                                            dataItem ? dataItem.totalIncome : ''
                                        }}
                                    </template>
                                    <template v-else>******</template>
                                </div>
                            </div>
                            <div class="flexItem alignR">
                                <i class="fa fa-angle-right color686868" @click="viewDetailList()"></i>
                            </div>
                        </div>
                        <div class="flexLayout font14r" style="margin-top: 20px;">
                            <div class="flexItem">
                                <div class="color777">
                                    今日收入
                                    <i class="icon eyeOpenedIcon size24 alignM" style="margin-top: -2px;"
                                       v-if="showTodayIncome" @click.prevent="showTodayIncome=!showTodayIncome"></i>
                                    <i class="icon eyeClosedIcon size24 alignM" style="margin-top: -2px;"
                                       v-else @click.prevent="showTodayIncome=!showTodayIncome"></i>
                                </div>
                                <div class="color101010" style="margin-top: 18px; min-height: 20px;">
                                    <template v-if="showTodayIncome">
                                      ￥{{ dataItem ? dataItem.totalIncome : '' }}
                                    </template>
                                    <template v-else>******</template>

                                </div>
                            </div>
                            <div class="flexItem">
                                <div class="color777">
                                    本月收入
                                    <i class="icon eyeOpenedIcon size24 alignM" style="margin-top: -2px;"
                                       v-if="showMonthIncome" @click.prevent="showMonthIncome=!showMonthIncome"></i>
                                    <i class="icon eyeClosedIcon size24 alignM" style="margin-top: -2px;"
                                       v-else @click.prevent="showMonthIncome=!showMonthIncome"></i>
                                </div>
                                <div class="color101010" style="margin-top: 18px; min-height: 20px;">
                                    <template v-if="showMonthIncome">￥{{
                                            dataItem ? dataItem.monthIncome : ''
                                        }}
                                    </template>
                                    <template v-else>******</template>
                                </div>
                            </div>
                        </div><!-- end .flexLayout -->

                        <div class="flexLayout font14r" style="margin-top: 20px;">
                            <div class="flexItem">
                                <div class="color777">
                                    钱包（可提现）
                                    <i class="icon eyeOpenedIcon size24 alignM" style="margin-top: -2px;"
                                       v-if="showWithdrawAbleMoney" @click.prevent="showWithdrawAbleMoney=!showWithdrawAbleMoney"></i>
                                    <i class="icon eyeClosedIcon size24 alignM" style="margin-top: -2px;"
                                       v-else @click.prevent="showWithdrawAbleMoney=!showWithdrawAbleMoney"></i>
                                </div>
                                <div class="color101010" style="margin-top: 32px; min-height: 20px;">
                                    <template v-if="showWithdrawAbleMoney">￥{{
                                            dataItem ? dataItem.withdrawAbleMoney : ''
                                        }}
                                    </template>
                                    <template v-else>******</template>

                                </div>
                            </div>
                            <div class="flexItem">
                                <div class="color777">
                                    冻结金额
                                    <i class="icon eyeOpenedIcon size24 alignM" style="margin-top: -2px;"
                                       v-if="showUnbalanceMoney" @click.prevent="showUnbalanceMoney=!showUnbalanceMoney"></i>
                                    <i class="icon eyeClosedIcon size24 alignM" style="margin-top: -2px;"
                                       v-else @click.prevent="showUnbalanceMoney=!showUnbalanceMoney"></i>
                                </div>
                                <div class="color101010" style="margin-top: 32px; min-height: 20px;">
                                    <template v-if="showUnbalanceMoney">
                                        ￥{{dataItem ? dataItem.unbalanceMoney : '' }}
                                    </template>
                                    <template v-else>******</template>
                                </div>
                            </div>
                        </div><!-- end .flexLayout -->
                    </div>

                </div><!-- end .borderBBB -->

                <div class="alignC" style="margin-top: 150px;">
                    <router-link v-show="!isExpired()" :to="{name : 'distributorWithdrawCash'}" class="withdrawCashButton">我要提现</router-link>
                    <router-link :to="{name : 'distributorWithdrawRequestList'}" class="withdrawCashRecordButton"
                                 style="margin-top: 7px;">提现明细</router-link>
                </div>

            </div>
        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import myTeam from "@comp/distributor/myTeam";

// config
import appConfig from '@/appConfig';

// util
import appHelper from '@/util/appHelper';

const config = {
    name: 'distributorIncomeManage',
    title: '收益管理',
    description: '',
    apiConfig: {
        get : {
            url: 'portal/v2/account/myIncome'
        },
    }
};

export default {
    name: config.name,
    extends: shixunPagePart,
    components: {
        myTeam
    },
    data() {
        return {
            title: config.title,
            description: config.description,
            apiConfig: config.apiConfig,

            enableDataItem : true,

            showTotalIncome : false,
            showTodayIncome : false,
            showMonthIncome : false,

            showWithdrawAbleMoney : false,
            showUnbalanceMoney : false,

        }
    },
    methods: {
        viewDetailList() {
            appHelper.goToPage('distributionIncomeDetailList');
        },
        isExpired()
        {
            if (!this.dataItem)
            {
                return false;
            }

            if (this.dataItem.expireTime < new Date().getTime())
            {
                return true;
            }

            return false;
        }

    },
    mounted() {

        this.loadDataItem();

        if (appConfig.mode === 'demo') {
            this.dataItem = {
                id: 1,
                title: '',
                coverImg: appHelper.getRandomCoverImage(),
                userHead: appHelper.getRandomCoverImage()
            };
        }
    }
}
</script>

<style lang="scss" scoped>
.bottomBorderBBB {
    border-bottom: solid 1px #BBB;
}
.color777 {
    color: #777;
}
.color101010 {
    color: #101010;
}
.color686868 {
    color: #686868;
}
.eyeOpenedIcon {
    background-image: url('data:image/png;base64,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');
}
.eyeClosedIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEDklEQVRoQ+2XW0gUcRTGWy+b61oQRBhEvnSBMqMskMqXqIgIXwKJguqhgpBMxdX1IZCC9up2IV8kCioKJIgeEqweguhC0YVUopfEohsFFdkuZWq/s8wu4+7Mju6MhjADf3Yu5/J953z/yzpmTPPLMc3xz7AJ/O8O2h2wO2CyAraETBbQtLvdAdMlNBnA7oDJApp2n/4daG1tzSssLNwzMjLyxOv19pguyRQE8Pv9K3Nycsqj0ehFRyAQuOFwOKqUvEGPx+PleXQKcEw4BcXOodg+HJsU5+uOYDA4yINbFa0LdnsbGxu/TjjDJDqEw+G5qOQqKTap0sSEwBleHFbnHh0d/clzCCIROvJrEnEZhqbqFL2wDkyijFkpOM/GJzEkDmJwGoOCFIMvvAujtbMEihpms9BAgLtcrkPkF7nMS8EV5X19U1NTR3IVYi4sxeg8H9al4oDcF/nGuNDc3PzaQpxpoSjmYl7uY+xPBa4YPwPPrgSOtGWUGb4TEiHGAi2gOD9GWl18u1VSUvK4urp62Ayhzs7O3IGBgTXoewtxtpG3QifvH74dRw1+uvM3YaO5D2BQgO5qMTrGmJkBYAxCfXzv4bcXYr35+fk99fX1H7V8qG4xIEqHh4fLsF2OzQpGKcNlUITLxD9B1V+l2uluZJFIxDU0NPSEhJLof16fILyspaXlmxYITQIK+Dsa86GLSpTyfuEkMRI5yqo3Wx1fuozEKrVIpBHQAk+Ab4DeyKx/IYF9Pt+qvLy8KoJK+yv05ss4SL7H5pHIjxgPiHmvoaEhxjxczvM9xpxEDD0SYwi0t7cXDQ4OdqsrL+AZlRwzROtpF8nWoef7qkRvuL+kA36zOrbcs8881Ik7LhJJAsqGcZdga1VgMoIXOwgcgEBHwoeurIfsAy1QbW1tS9Czehk+QFfP6XVKrxNOp3MDC8V38UsSYIXwijomAl5s8TvFz5GEH1Ut0tu9Zcns7++XTcip2J+EQEMmqWmRwD6Mn2cMATayZgL75aWRbNQJIXCb5/j5BL+3LHUlmQCR5yV5ZPkU+27st2ayV7qcKqd0AoqEGnGoRAZ1eppPTQagDwCarwC6CaDtBgSuYr9TsXlHJce1orFwLMrNzfVA+jOjDXw/xnTAqApa30OhkJtgcpqNX9wHICBS1L0gfBQCskHGL7fbPaumpiYZY6I4TP0jQz6rSfg0kRRgu9H/lUwg8NnB92sJG7pdZuaPlCkCyM7JkUMIlMoRPBaLFRudWpWuyVIrJ8yXnG3K1WebKe2AJBMSHHulE33IR/5HGF7KUbkMv+e1tbW/DR0yGJjqgJnEVvnaBKyqZLZx7A5kWzmr/OwOWFXJbOPYHci2clb52R2wqpLZxrE7kG3lrPKb9h34B0a8zdJOyP3fAAAAAElFTkSuQmCC');
}
.withdrawCashButton {
    display: inline-block;
    width: 260px;
    height: 37px;
    line-height: 37px;
    padding: 0;
    border-radius: 19px;
    font-size: 14px;
    text-align: center;
    background: #FEA217;
    border: 1px solid rgba(254, 162, 23, 100);
    color: white;
}
.withdrawCashRecordButton {
    display: inline-block;
    width: 260px;
    height: 37px;
    line-height: 37px;
    padding: 0;
    border-radius: 19px;
    font-size: 14px;
    text-align: center;
    background: transparent;
    border: 1px solid rgba(254, 162, 23, 100);
    color: #FEA217;
}
</style>
